import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { ClockInTypeActionTypes } from '../State/actions/clock-in-type.actions';
import { getClockInTypesFetched } from '../State/selectors/clock-in-type.selectors';
import { BaseEntityResolver } from './resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class ClockInTypeResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getClockInTypesFetched, ClockInTypeActionTypes.Load(), store);
    }
}
